import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { webApi } from "@/lib/webApi";
import { Shell, StartOnWhatsApp, usePublicLinks } from "@/pages/web/WebLogin";

export function WebVerify() {
  const nav = useNavigate();
  const ran = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = new URLSearchParams(window.location.hash.slice(1)).get("t");
    window.history.replaceState(null, "", window.location.pathname);
    if (!token) {
      setFailed(true);
      return;
    }
    webApi.post("/auth/consume", { token })
      .then(() => nav("/app", { replace: true }))
      .catch(() => setFailed(true));
  }, [nav]);

  return (
    <Shell>
      {!failed ? (
        <p className="flex items-center gap-2 text-slate-300" data-testid="web-verify-loading"><Loader2 className="h-4 w-4 animate-spin" /> Signing you in...</p>
      ) : (
        <div data-testid="web-verify-failed">
          <h1 className="font-display text-3xl font-bold text-slate-100">Link expired</h1>
          <p className="mt-3 text-slate-400">This link has expired or was already used. Send <span className="text-slate-200">LOGIN</span> on WhatsApp for a new one.</p>
          <Link to="/app/login" className="mt-6 inline-block text-amber-300 hover:underline" data-testid="web-verify-back-link">Back to sign in</Link>
        </div>
      )}
    </Shell>
  );
}

export function Welcome() {
  const links = usePublicLinks();
  return (
    <Shell>
      <p className="text-xs uppercase tracking-[0.25em] text-amber-300/80">Dicta Web</p>
      <h1 className="mt-3 font-display text-4xl font-bold leading-tight text-slate-100 sm:text-5xl">Your matters, files and plan, on a bigger screen.</h1>
      <p className="mt-4 text-slate-400">Everything you've shared with Dicta on WhatsApp, filed by matter and kept in your own encrypted store.</p>
      <Link to="/app/login" data-testid="welcome-sign-in-button"
        className="mt-8 inline-flex w-fit items-center rounded-md bg-amber-300 px-5 py-3 font-semibold text-[#07090D] transition-transform duration-150 hover:-translate-y-0.5">
        Sign in
      </Link>
      <StartOnWhatsApp href={links.wa_start} />
    </Shell>
  );
}
